import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDiff',
  standalone: true
})
export class TimeDiffPipe implements PipeTransform {

  transform(value: Date | string): string {
    if (!value) return '';

    const currentTime = new Date().getTime();
    const pastTime = Date.parse(value.toString().endsWith('+00:00') || value.toString().endsWith('Z') ? value.toString() : `${value}Z`);
    if (isNaN(pastTime)) return '';
    const timeDiffMs = currentTime - pastTime;

    const oneMinute = 60 * 1000;
    const oneHour = 60 * oneMinute;
    const oneDay = 24 * oneHour;
    const oneWeek = 7 * oneDay;

    if (timeDiffMs < oneMinute) {
      return 'just now';
    } else if (timeDiffMs < oneHour) {
      const minutes = Math.floor(timeDiffMs / oneMinute);
      return `${minutes} minutes ago`;
    } else if (timeDiffMs < oneDay) {
      const hours = Math.floor(timeDiffMs / oneHour);
      return `${hours} hours ago`;
    } else if (timeDiffMs < oneWeek) {
      const days = Math.floor(timeDiffMs / oneDay);
      return `${days} days ago`;
    } else {
      const pastDate = new Date(pastTime);
      return pastDate.toISOString().slice(0, 19).replace('T', ' ');
    }
  }
}
